import React from 'react';
import BaseIcon from './BaseIcon';

interface TableIconProps {
  className?: string;
}

const TableIcon: React.FC<TableIconProps> = ({ className }) => (
  <BaseIcon className={className}>
    <path d="M20 10c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8z"></path>
    <path d="M4 10V6c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2v4"></path>
    <path d="M4 14h16"></path>
  </BaseIcon>
);

export default TableIcon;
